var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumber3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#8100D9",
    fillOpacity: 0.94
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.07 47.456c-7.41 0-10.868-6.422-10.868-13.11S15.66 21.274 23.07 21.274s10.868 6.384 10.868 13.072c0 6.688-3.458 13.11-10.868 13.11zm0-5.776c3.04 0 4.256-2.85 4.256-7.334S26.11 27.05 23.07 27.05s-4.256 2.812-4.256 7.296 1.216 7.334 4.256 7.334zm22.953 5.776c-4.864 0-8.512-1.71-10.488-3.99l3.306-4.446c1.824 1.786 4.712 2.66 6.916 2.66 2.812 0 4.256-1.064 4.256-2.47 0-1.444-1.064-2.128-4.522-2.128-1.102 0-3.04 0-3.42.038v-5.814c.494.038 2.47.038 3.42.038 2.622 0 4.104-.646 4.104-1.976 0-1.596-1.824-2.318-4.256-2.318-2.318 0-4.522.836-6.308 2.432l-3.154-4.104c2.128-2.394 5.472-4.104 10.146-4.104 6.46 0 10.07 2.774 10.07 6.954 0 2.964-2.546 5.206-5.548 5.7 2.698.266 5.966 2.356 5.966 6.004 0 4.446-4.18 7.524-10.488 7.524z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber3);
export default __webpack_public_path__ + "static/media/Number3.bd0ab063f9494fcb48aa1138d86e44d9.svg";
export { ForwardRef as ReactComponent };